import { render, staticRenderFns } from "./oddevenTable.vue?vue&type=template&id=50ccd3db"
import script from "./oddevenTable.vue?vue&type=script&lang=js"
export * from "./oddevenTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports